import { render, staticRenderFns } from "./LatestListing.vue?vue&type=template&id=1190dad3&scoped=true&"
import script from "./LatestListing.vue?vue&type=script&lang=js&"
export * from "./LatestListing.vue?vue&type=script&lang=js&"
import style0 from "./LatestListing.vue?vue&type=style&index=0&id=1190dad3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1190dad3",
  null
  
)

export default component.exports